// extracted by mini-css-extract-plugin
export default {"vjsf":"vjsf--E4P_e"};